var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import classNames from "classnames";
import AntSelect from "antd/es/select";
import FeatherIcons from "../Icons/FeatherIcons";
import { addChildrenA11yAttributes, addOptionsPropA11yAttributes, defaultFilterOption, withStaticProps, } from "./helpers";
const InnerSelect = forwardRef((_a, ref) => {
    var { name, size = "large", suffix, children, ariaLabel, className, showArrow = true, dropdownName, hasCheckmark, menuItemSelectedIcon, onChange, onSelect, filterOption: filterOptionProp, options, listHeight, optionLabelProp } = _a, props = __rest(_a, ["name", "size", "suffix", "children", "ariaLabel", "className", "showArrow", "dropdownName", "hasCheckmark", "menuItemSelectedIcon", "onChange", "onSelect", "filterOption", "options", "listHeight", "optionLabelProp"]);
    const classes = classNames("gerudo-select", className);
    const updatedSize = size === "small" || size === "default" ? "middle" : size;
    let filterOption;
    if (typeof filterOptionProp === "function") {
        filterOption = filterOptionProp;
    }
    else if (filterOptionProp === true || filterOptionProp === undefined) {
        filterOption = defaultFilterOption;
    }
    else {
        filterOption = false;
    }
    const selectedIcon = menuItemSelectedIcon !== null && menuItemSelectedIcon !== void 0 ? menuItemSelectedIcon : (hasCheckmark && React.createElement(FeatherIcons, { name: "Check" }));
    if (options) {
        options = addOptionsPropA11yAttributes(options);
    }
    if (children) {
        children = addChildrenA11yAttributes(children);
    }
    return (React.createElement("div", { className: classes },
        React.createElement(AntSelect, Object.assign({ ref: ref, optionLabelProp: optionLabelProp }, { name: name }, { showArrow: showArrow, "aria-label": ariaLabel, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: onChange, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onSelect: onSelect, size: updatedSize, menuItemSelectedIcon: selectedIcon, getPopupContainer: (element) => element.parentNode, dropdownRender: (dropdown) => React.createElement("div", Object.assign({}, { name: dropdownName || name }), dropdown), notFoundContent: "No results", suffixIcon: suffix, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filterOption: filterOption, options: options, listHeight: listHeight, dropdownMatchSelectWidth: true }, props), children)));
});
InnerSelect.displayName = "Select";
// Ant's Select does some weiiiiiiiiird shit with those. Wrapping them in a custom component breaks
// their usage and their wrapper component is never even called. The best we can do to control their
// props interface is export them AS a certain type
const Option = AntSelect.Option;
const OptGroup = AntSelect.OptGroup;
const Select = withStaticProps(InnerSelect, {
    Option,
    OptGroup,
});
// This is stupid but is a workaround for ReactElement type checks when using react-hot-loader
// https://github.com/gaearon/react-hot-loader/issues/304
export const OptionType = (React.createElement(Option, { value: "whatever" }, "whatever")).type;
Select.displayName = "Select";
export default Select;
export { Select, Option, OptGroup };
//# sourceMappingURL=Select.js.map